export const ProfileStatusTypeEnum={
    "Aadhar" : "Aadhar",
    "Video" : "Video",
    "ESign" : "ESign"

}